import { createActionGroup, emptyProps } from '@ngrx/store';
import { CmsPageUrl, Widget } from '@core/models';

export const CmsActions = createActionGroup({
  source: 'Cms',
  events: {
    'Get Page Widgets': (url: CmsPageUrl) => ({ url }),
    'Get Page Widgets Success': (url: CmsPageUrl, widgets: Widget[]) => ({
      url,
      widgets,
    }),
    'Get Page Widgets Failure': emptyProps(),

    'Get Footer': emptyProps(),
    'Get Footer Success': (url: CmsPageUrl, widgets: Widget[]) => ({
      url,
      widgets,
    }),
    'Get Footer Failure': emptyProps(),
  },
});
